import React, { useCallback, useState } from 'react'
import { Flyout, FlyoutTrigger } from '@zambezi/sdk/flyout'
import { Icon } from '@zambezi/sdk/icons'
import { PropTypes } from 'prop-types'
import { useGlobalId } from '@zambezi/sdk/common'

/**
 * @type {React.FunctionComponent<import('./interfaces').HintProps>}
 * @param {import('./interfaces').HintProps} props
 */
export default function Hint (props) {
  const globalId = useGlobalId('zb-hint-')
  const id = props.id || globalId
  const {
    children,
    openIconName,
    iconName,
    iconSize,
    title,
    onShow,
    onHide
  } = props
  const [isOpen, setIsOpen] = useState(false)
  const flyout = <Flyout id={id}>{children}</Flyout>
  /** @type {(event: React.SyntheticEvent) => void} */
  const handleOnHide = useCallback((event) => {
    setIsOpen(false)
    onHide(event)
  }, [onHide])
  /** @type {(event: React.SyntheticEvent) => void} */
  const handleOnShow = useCallback((event) => {
    setIsOpen(true)
    onShow(event)
  }, [onShow])

  return (
    <FlyoutTrigger flyout={flyout} {...props} onHide={handleOnHide} onShow={handleOnShow}>
      <button className='zb-hint-trigger' type='button'>
        <Icon
          name={isOpen ? openIconName || iconName : iconName}
          title={title || 'Toggle hint'}
          size={iconSize}
          className='zb-hint-trigger-icon'
        />
      </button>
    </FlyoutTrigger>
  )
}

function noop () {}

Hint.defaultProps = {
  position: 'top',
  iconName: 'information-xsmall',
  title: 'Toggle hint',
  onShow: noop,
  onHide: noop
}

Hint.propTypes = {
  children: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  iconName: PropTypes.string,
  iconSize: PropTypes.string,
  openIconName: PropTypes.string,
  id: PropTypes.string,
  position: FlyoutTrigger.propTypes.position,
  onShow: PropTypes.func,
  onHide: PropTypes.func,
  showOn: FlyoutTrigger.propTypes.showOn,
  delayShow: FlyoutTrigger.propTypes.delayShow,
  delayHide: FlyoutTrigger.propTypes.delayHide,
  title: PropTypes.string
}
